import { render, staticRenderFns } from "./shuttleReservation.vue?vue&type=template&id=4abcc9fd&scoped=true&"
import script from "./shuttleReservation.vue?vue&type=script&lang=js&"
export * from "./shuttleReservation.vue?vue&type=script&lang=js&"
import style0 from "./shuttleReservation.vue?vue&type=style&index=0&id=4abcc9fd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abcc9fd",
  null
  
)

export default component.exports